import { createReducer } from 'typesafe-actions'
import { ContactAction, ContactState } from './types'
import {
  createContactHandle,
  fetchContactsByCompanyHandle,
  setCurrentContactHandle,
  updateContactHandle
} from './handles'

const initialState: ContactState = {
  contacts: [],
  isErrorOnCreateContact: false,
  isLoadingCreateContact: false,
  isSuccessCreateContact: false,
  isErrorOnUpdateContact: false,
  isLoadingUpdateContact: false,
  isSuccessUpdateContact: false,
  isSuccessFetchContactsByCompany: false,
  isLoadingFetchContactsByCompany: false,
  isErrorOnFetchContactsByCompany: false,
  currentContact: null
}

export const contactReducer = createReducer<ContactState, ContactAction>(initialState)
  .handleAction(createContactHandle.asyncAction.request, createContactHandle.request)
  .handleAction(createContactHandle.asyncAction.success, createContactHandle.success)
  .handleAction(createContactHandle.asyncAction.failure, createContactHandle.failure)
  .handleAction(updateContactHandle.asyncAction.request, updateContactHandle.request)
  .handleAction(updateContactHandle.asyncAction.success, updateContactHandle.success)
  .handleAction(updateContactHandle.asyncAction.failure, updateContactHandle.failure)
  .handleAction(fetchContactsByCompanyHandle.asyncAction.request, fetchContactsByCompanyHandle.request)
  .handleAction(fetchContactsByCompanyHandle.asyncAction.success, fetchContactsByCompanyHandle.success)
  .handleAction(fetchContactsByCompanyHandle.asyncAction.failure, fetchContactsByCompanyHandle.failure)
  .handleAction(setCurrentContactHandle.asyncAction, setCurrentContactHandle.success)
